import { createTRPCReact } from '@trpc/react-query';
import { httpBatchLink } from '@trpc/client';
import superjson from 'superjson';
import type { AppRouter } from '@leafstock/api/src/router';

export const trpc = createTRPCReact<AppRouter>();

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3001';

export function createTRPCClient(authToken: string, businessCode?: string) {
  return trpc.createClient({
    transformer: superjson,
    links: [
      httpBatchLink({
        url: `${API_URL}/trpc`,
        fetch(url, options) {
          const controller = new AbortController();
          const timeoutId = setTimeout(() => {
            controller.abort();
          }, 15000); // 15s timeout

          return fetch(url, {
            ...options,
            signal: controller.signal,
          })
            .finally(() => clearTimeout(timeoutId));
        },
        headers() {
          const headers: Record<string, string> = {};

          if (authToken) {
            headers['Authorization'] = `Bearer ${authToken}`;
          }

          if (businessCode) {
            headers['X-Business-Code'] = businessCode;
          }

          return headers;
        },
      }),
    ],
  });
}
